<script>
    import { mapActions, mapState } from 'vuex';
    import { Form } from "element-ui";
    import Vue from 'vue';
    import VueRecaptcha from 'vue-recaptcha';
    import Loader from '~/components/loader/components/loader';

    Vue.use(Form);

    export default {
        name: 'recaptcha',

        components: {
            Loader,
            VueRecaptcha
        },

        methods: {
            ...mapActions('passwordSettings', [
                'setRecaptchaSiteKey',
                'validateRecaptcha'
            ]),

            onVerify: function (responseToken) {
                this.validateRecaptcha(responseToken).then(response => {
                    this.$emit('validationComplete', response.isValid);
                });
            },

            resetRecaptcha() {
                this.$refs.recaptcha.reset();
            }
        },

        mounted() {
            this.setRecaptchaSiteKey();
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'recaptchaSiteKey'
            ])
        },
    }
</script>

<template>
    <div>
        <loader :is-loading="loading.recaptcha"></loader>

        <vue-recaptcha v-if="recaptchaSiteKey !== null"
                       ref="recaptcha"
                       @verify="onVerify"
                       :sitekey="recaptchaSiteKey"
                       style="transform:scale(1.16);transform-origin:0 0;">
        </vue-recaptcha>
    </div>
</template>